import { createReducer } from 'src/utils/reducer'
import * as actionTypes from 'src/constants/actionTypes'

export default createReducer(
    {
        messages: [],
    },
    {
        [actionTypes.TOAST_SHOW]: (state, action) => {
            return {
                ...state,
                messages: state.messages.concat([action.message]),
            }
        },
        [actionTypes.TOAST_REMOVE]: (state, action) => {
            // Remove the message by passing the same object, or remove the message by passing the same key.
            let messages = state.messages.filter((message) => {
                if (message.key && action.message.key) {
                    return message.key !== action.message.key
                }
                return message !== action.message
            })
            return { ...state, messages: messages }
        },
    }
)
